// Body of the password-reset confirm view: the legacy account-page layout. Two
// states, selected server-side by Django's validlink: the valid state renders
// the SetPasswordForm as a native React field tree under the "Enter a new
// password for <email>" prompt (the copy on either side of the email arrives
// pre-localized and split around the styled span); the invalid state renders
// the error heading + a button back to the request page. This page carries NO
// customer-service block (legacy parity). The brand + section headings arrive
// as props; the invalid-branch button label is a site-local literal (en-us).
import { Immutable } from "immer";
import React from "react";
import { FormFields } from "tsi-common-react/src/apps/customer-account/FormFields/index";
import { FORM_FIELD_SUBMIT_CLASS_NAME } from "tsi-common-react/src/forms/classNames";
import { useStaticURL } from "tsi-common-react/src/utils/urls";

import { templates } from "@reactivated";

import { CSRFToken } from "@reactivated/forms";

type IProps = Immutable<templates.PasswordResetConfirmDocumentTemplate>;

export const PasswordResetConfirmBody = (props: IProps): React.JSX.Element => {
    const staticURL = useStaticURL();
    return (
        <div className="l-capped-width">
            <header>
                <h1>{props.page_copy?.page_heading}</h1>
            </header>

            <section className="account-page-container">
                <div>
                    {props.valid_link ? (
                        <>
                            <h2>{props.page_copy?.section_heading}</h2>
                            <div>
                                <p>
                                    {props.email_prompt_lead}
                                    <span className="utility-page__text-blue">
                                        {props.user_email}
                                    </span>
                                    {props.email_prompt_tail}
                                </p>
                                <form
                                    id="password_reset_form"
                                    className="js-kuid-form"
                                    action={props.action_url}
                                    method="post"
                                >
                                    <CSRFToken />
                                    <FormFields
                                        fields={props.fields}
                                        field_labels={props.field_labels}
                                        field_errors={props.field_errors}
                                        non_field_errors={
                                            props.non_field_errors
                                        }
                                    />
                                    <div
                                        className={FORM_FIELD_SUBMIT_CLASS_NAME}
                                    >
                                        <input
                                            type="submit"
                                            className="button button--full-width"
                                            value={props.submit_text}
                                        />
                                    </div>
                                </form>
                            </div>
                        </>
                    ) : (
                        <>
                            <h2>{props.invalid_heading}</h2>
                            <div>
                                <p>
                                    <a
                                        href={props.reset_url}
                                        className="button"
                                    >
                                        Reset Your Password
                                    </a>
                                </p>
                            </div>
                        </>
                    )}
                </div>
                <div>
                    {props.page_copy?.account_image ? (
                        <img
                            src={`${staticURL}img/accounts/${props.page_copy.account_image}`}
                            alt={props.page_copy.account_image_alt}
                        />
                    ) : null}
                </div>
            </section>
        </div>
    );
};
